var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_10053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8086 2.58997C7.62191 2.58997 6.46187 2.94186 5.47518 3.60115C4.48848 4.26044 3.71945 5.19751 3.26532 6.29387C2.81119 7.39022 2.69237 8.59662 2.92388 9.76051C3.1554 10.9244 3.72684 11.9935 4.56596 12.8326C5.40507 13.6717 6.47417 14.2432 7.63805 14.4747C8.80194 14.7062 10.0083 14.5874 11.1047 14.1332C12.2011 13.6791 13.1381 12.9101 13.7974 11.9234C14.4567 10.9367 14.8086 9.77665 14.8086 8.58997C14.8086 8.2833 14.7819 7.97663 14.7419 7.6833C14.4088 8.1504 13.9687 8.53094 13.4583 8.79307C12.948 9.05519 12.3823 9.19129 11.8086 9.18997C11.0454 9.18998 10.3019 8.94759 9.68539 8.49774C9.06887 8.04789 8.61116 7.41384 8.37829 6.68704C8.14541 5.96024 8.14941 5.17825 8.38971 4.45387C8.63 3.72949 9.09417 3.10015 9.71526 2.65663C9.42193 2.61663 9.11526 2.58997 8.8086 2.58997Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_10053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.808594 0.589966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMoon);
export default __webpack_public_path__ + "static/media/dark-moon.1e447ede984667ca7a3599414f3ec586.svg";
export { ForwardRef as ReactComponent };